import React from "react"
import { IntlContextConsumer, changeLocale, FormattedMessage, injectIntl } from "gatsby-plugin-intl"

const languageName = {
	es: "Español",
	en: "English",
}

const Language = () => {
  return (
    <div>
		<FormattedMessage id="header.idioma" />
		<div className="drop">
			<IntlContextConsumer>
				{({ languages, language: currentLocale }) =>
				languages.map(language => (
					<button
					key={language}
					onClick={() => changeLocale(language)}
					style={{
						color: currentLocale === language ? `#FF5035` : `#383A35`,
					}}
					>
					{languageName[language]}
					</button>
				))
				}
			</IntlContextConsumer>
		</div>
    </div>
  )
}

export default injectIntl(Language)
